import { toast } from "sonner";
import { create } from "zustand";

export interface FileConflictModalStore {
  isOpen: boolean;
  fileName: string;
  filePath: string;
  isProcessing: boolean;
  onReplace: (() => Promise<void>) | null;
  onCancel: () => void;
  showModal: (
    fileName: string,
    filePath: string,
    replaceAction: () => Promise<void>,
  ) => Promise<boolean>;
  hideModal: () => void;
}

export const useFileConflictModalStore = create<FileConflictModalStore>(
  (set, get) => ({
    isOpen: false,
    fileName: "",
    filePath: "",
    isProcessing: false,
    onReplace: null,
    onCancel: () => {},
    showModal: async (fileName, filePath, replaceAction) => {
      return new Promise((resolve) => {
        set({
          isOpen: true,
          fileName,
          filePath,
          onReplace: async () => {
            if (get().isProcessing) return;
            set({ isProcessing: true });
            let success = false;
            try {
              await replaceAction();
              success = true;
              toast.success(`File ${fileName} replaced successfully`);
            } catch (error) {
              success = false;
              toast.error(`Error replacing file ${fileName}`);
            } finally {
              set({
                isProcessing: false,
                isOpen: false,
                fileName: "",
                filePath: "",
                onReplace: null,
                onCancel: () => {},
              });
              resolve(success);
            }
          },
          onCancel: () => {
            if (get().isOpen) {
              set({
                isOpen: false,
                fileName: "",
                filePath: "",
                isProcessing: false,
                onReplace: null,
                onCancel: () => {},
              });
              resolve(false);
            }
          },
        });
      });
    },
    hideModal: () => {
      set({
        isOpen: false,
        fileName: "",
        filePath: "",
        isProcessing: false,
        onReplace: null,
        onCancel: () => {},
      });
    },
  }),
);

export const showFileConflictModal = async (
  fileName: string,
  filePath: string,
  replaceAction: () => Promise<void>,
) => {
  return useFileConflictModalStore
    .getState()
    .showModal(fileName, filePath, replaceAction);
};
